/**
 * Created by wjk on 2016/12/27.
 */
/*eslint-disable*/
let apiLinks
let loginStatus = window.document.cookie.indexOf('tenantid')
// let domains = 'https://'
// 开发环境 dev http://yc.yonyou.com 92
// 正式环境 https://www.yonyouyc.com 562
// let yc = 'https://www.yonyouyc.com'
// yc
// let enterpriseId = 312

// a
// let enterpriseId = 2
// demo环境
// let enterpriseId = 43616
// let yc = 'https://ycdemo.yonyoucloud.com'
// let tenantid = 'cvil789o'
// // 正式环境
let enterpriseId = 284
let yc = 'https://yc.yonyoucloud.com'
let tenantid = 'vi41ji8w'

// 测试环境
// let enterpriseId = 312
// let yc = 'http://yc.yonyou.com'
// let tenantid = 'djdw1q2n'
// let curlinks = 'http://' + window.location.host


if(loginStatus>0){
  // 已经登录
  apiLinks = {
    // 查询南方水泥的
    materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
    orgClass: yc + '/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' + enterpriseId,
    // 南方水泥各链接
    southCement: {
      home: 'http://www.shanghaiwater.com/'
    },
    caslogout: '/yuncai/caslogout',
    // 注册页面
    register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=chengtou',
    // 进入工作台/注册
    enterWorkbench: yc + '/workbench/sso/login.jsp',
    // 供应商申请
    suppliersFor: yc + '/yuncai/SSO/registerredirect4yuncaismi.html?v=' + Date.parse(new Date().toLocaleDateString()),
    // 首页左侧数据相关链接
    infoTable: {
      latest: [
        yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
        'latest2',
        'latest3'
      ],
      area: [
        yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
        'area2',
        'area3',
        'area4',
        'area5',
        'area6',
        'area7',
        'area8'
      ],
      type: [
        yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
        '2',
        '3',
        '4'
      ]
    },
    // 物资招标公告链接(之后封装成一个对象目前只有两个)
    purchasetableDate: [
      // 询价公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=5,10&pageSize=10&pageIndex=0',
      // 竞价公告
      '',
      // 竞价性谈判
      ''
    ],
    // 物流招标公告链接
    logisticstableDate: [
      // 询价公告
      '',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0',
      // 竞价公告
      '',
      // 竞价性谈判
      ''
    ],
    // 工程招标公告链接
    logisticsestableDate: [
      // 询价公告
      '',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=11&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=13&pageSize=10&pageIndex=0'
    ],
    // 服务招标公告链接
    engineeringtableDate: [
      // 询价公告
      '',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=12,24&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=14&pageSize=10&pageIndex=0'
    ],
    // 查看详情不同status跳转页面 bidDetails: cpu-fe-bid -> cpu-fe-tender
    details: {
      bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
      bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
      biddocDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowbiddoc/index.html?show=1&id=',
      bidNotice: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
      bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
      bidMsg2: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
      // 竞价招标公告
      bidMsg3: yc + '/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id=',
      inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
      company: yc + '/gwmanage/pages/notice/detail.html?id=',
      noticeMore: yc + '/cpu-dashboard-fe/index.html#/anoucementlist?tenantid=' + tenantid,
    },
    // 首页右侧数据相关链接  vi41ji8w
    notice: {
      company: '/gwmanage/pub/notice/entnotice?tenantid='+ tenantid +'&pageIndex=1&pageSize=6&key=',
      bidding: yc + '/yuncai/ctjsonp/supplierOffer/ctloginlist?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageIndex=0&pageSize=6',
      clarify: ''
    },
    // 联系我们页面
    contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId,
    // 是否已申请过供应商
    agreement: yc + '/cpu-supplymgr/supplyApply/isExistApply?purEntId=' + enterpriseId
  }
}else{
  // 未登录
  apiLinks = {
    // 查询南方水泥的
    materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
    orgClass: yc + '/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' + enterpriseId,
    // 南方水泥各链接
    southCement: {
      home: 'http://www.shanghaiwater.com/'
    },
    caslogout: '/yuncai/caslogout',
    // 注册页面
    register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=chengtou',
    // 进入工作台/注册
    enterWorkbench: yc + '/workbench/sso/login.jsp',
    // 供应商申请
    suppliersFor: yc + '/yuncai/SSO/registerredirect4yuncaismi.html?v=' + Date.parse(new Date().toLocaleDateString()),
    // 首页左侧数据相关链接
    infoTable: {
      latest: [
        yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
        'latest2',
        'latest3'
      ],
      area: [
        yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
        'area2',
        'area3',
        'area4',
        'area5',
        'area6',
        'area7',
        'area8'
      ],
      type: [
        yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
        '2',
        '3',
        '4'
      ]
    },
    // 物资招标公告链接(之后封装成一个对象目前只有两个)
    purchasetableDate: [
      // 询价公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=5,10&pageSize=10&pageIndex=0',
      // 竞价公告
      '',
      // 竞价性谈判
      ''
    ],
    // 物流招标公告链接
    logisticstableDate: [
      // 询价公告
      '',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0',
      // 竞价公告
      '',
      // 竞价性谈判
      ''
    ],
    // 工程招标公告链接
    logisticsestableDate: [
      // 询价公告
      '',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=11&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=13&pageSize=10&pageIndex=0'
    ],
    // 服务招标公告链接
    engineeringtableDate: [
      // 询价公告
      '',
      // 招标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=12,24&pageSize=10&pageIndex=0',
      // 中标公告
      yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=14&pageSize=10&pageIndex=0'
    ],
    // 查看详情不同status跳转页面 bidDetails: cpu-fe-bid -> cpu-fe-tender
    details: {
      bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
      bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
      biddocDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowbiddoc/index.html?show=1&id=',
      bidNotice: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
      bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
      bidMsg2: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
      // 竞价招标公告
      bidMsg3: yc + '/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id=',
      inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
      company: yc + '/gwmanage/pages/notice/detail.html?id=',
      noticeMore: yc + '/cpu-dashboard-fe/index.html#/anoucementlist?tenantid=' + tenantid,
    },
    // 首页右侧数据相关链接  vi41ji8w
    notice: {
      company: '/gwmanage/pub/notice/entnotice?tenantid='+ tenantid +'&pageIndex=1&pageSize=6&key=',
      bidding: yc + '/yuncai/ctjsonp/supplierOffer/ctlist?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageIndex=0&pageSize=6',
      clarify: ''
    },
    // 联系我们页面
    contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId,
    // 是否已申请过供应商
    agreement: yc + '/cpu-supplymgr/supplyApply/isExistApply?purEntId=' + enterpriseId
  }
}


export {apiLinks}



// WEBPACK FOOTER //
// ./src/api/links.js